import {
  AppBar, Button, Container, Grid, Link, Toolbar, Typography,
} from '@material-ui/core';
import Autorenew from '@material-ui/icons/Autorenew';

import Mail from '@material-ui/icons/MailOutline';

import { withStyles } from '@material-ui/styles';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { doLogin } from '../../actions';

import LoginBackButton from '../../assets/images/login-button-icon.svg';
import headerLogo from '../../assets/images/logo-revbits.png';
import darkLogo from '../../assets/images/theme-switch-dark.svg';
import lightLogo from '../../assets/images/theme-switch-light.svg';
import dmLogo from '../../assets/images/up-login-dm-logo.png';
import lmLogo from '../../assets/images/update_portal_login.png';

import styles from '../../assets/jss/NewLoginScreenStyles';

import { ROUTE } from '../../constant';
import { constants } from '../../constant/constant';
import { CheckIfIterationCountIsValid, CheckIfNotEmpty } from '../../helper/StringUtils';
import { AuthService, EncryptionServices } from '../../services';

import { renderTextField } from '../Form/Fields';
import PasswordField from '../Form/PasswordField';
import { email, required } from '../Form/validate';

import CustomMessages from './CustomMessages';

const requiredUserName = required('VALIDATION.REQ_USERNAME');
const requiredPassword = required('VALIDATION.REQ_PASSWORD');
const requiredIterationCount = required('VALIDATION.REQ_ITRATION_COUNT');

// eslint-disable-next-line no-unused-vars
const onSubmit = async (values, dispatch, props) => {
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false,
      appCheck: false,
      isClient: AuthService.checkForClientApp(),
    };
    const urlParams = new URLSearchParams(window.location.search);
    this.sso = !!urlParams.get('sso');
    this.redirectURI = urlParams.get('redirect_uri');
    this.portal = urlParams.get('portal');
  }

  componentWillMount() {
    const { history } = this.props;
    history.state = {};
    history.push(ROUTE.LOGIN);
  }

  componentDidMount() {
    document.title = 'Software Update Portal - Login';
  }

  componentWillUnmount() {
    const { history } = this.props;
    history.state = {};
  }

  /**
   * submitLogin is for checking the email password and iteration count if these details
   * are correct then it will render to the private key dialouge box
   * @param event
   */

  /* submitLogin = event => {

    const {
      userName,
      password,
      iterationCount,
    } = this.props.formValues;

    if (CheckIfNotEmpty(userName) && CheckIfNotEmpty(password) && CheckIfNotEmpty(iterationCount) && CheckIfIterationCountIsValid(iterationCount)) {

      EncryptionServices.generateCredential(userName, password, iterationCount)
        .then(
          credentials => {

            doLogin(credentials, {
              sso: this.sso,
              redirectURI: this.redirectURI,
              portal: this.portal,
            }).then(res => {

              const data = res.data;

              if (data && data.status === 200 && data.response && data.response.token) {

                sessionStorage.setItem('cred', JSON.stringify(data.response));
                sessionStorage.setItem('displayImg', data.response.userData.avatar);

                EncryptionServices.decodeJwtToken(data.response.token).then(decVal => {
                  sessionStorage.setItem('userRole', decVal.role.roleName);

                  // check user login permissions
                  let appType = process.env.REACT_APP_AUDIENCE_TYPE;
                  let roleId = decVal.role.id;
                  if ((roleId === 1 || roleId === 2 || roleId === 4) && (appType)?.trim() === 'AdminApp') {
                    this.setState({
                      appCheck: true,
                    });
                  }

                  if (roleId === 3 && (appType)?.trim() === 'ClientApp') {
                    this.setState({
                      appCheck: true,
                    });
                  }
                  if (!this.state.appCheck) {
                    this.props.history.state = {
                      status: 'error',
                      msg: 'API.INVALID_CREDENTIALS',
                      show: true,
                    };
                    this.setState({isError: !this.state.isError})
                  } else {
                    if (decVal.challenged) {
                      if (decVal.defaultAuthMethod === constants.TFA_METHODS.sms2fa) {
                        this.props.history.push('/verify-sms');
                      } else if (decVal.defaultAuthMethod === constants.TFA_METHODS.u2f) {
                        this.props.history.push('/verify-securityKey');
                      } else {
                        this.props.history.push('/otp');
                      }
                    } else {
                      if (data.response.userData) {

                        const sso = data.response.userData.sso;
                        if (sso) {
                          const {
                            error,
                            errorMessage,
                            access_code,
                            redirect_uri,
                          } = data.response.userData;
                          if (error) {
                            if (redirect_uri.includes('http')) {
                              window.location.href = `${redirect_uri}?accessCode=''&error=${error}&errorMessage=${errorMessage}`
                            } else {
                              window.location.href = `https://${redirect_uri}?accessCode=''&error=${error}&errorMessage=${errorMessage}`
                            }
                          } else {
                            if (redirect_uri.includes('http')) {
                              window.location.href = `${redirect_uri}?accessCode=${access_code}`
                            } else {
                              window.location.href = `https://${redirect_uri}?accessCode=${access_code}`
                            }
                          }
                        } else {
                          sessionStorage.setItem('cred', JSON.stringify(data.response));
                          AuthService.authenticate(data.response.token);
                          this.props.getPermission();
                          this.props.history.push('/');
                        }
                      } else {
                        this.props.history.state = {
                          status: 'error',
                          msg: 'API.INVALID_CREDENTIALS',
                          show: true,
                        };
                        this.setState({isError: !this.state.isError})
                      }
                    }
                  }
                });
              } else {
                if (res && res.data) {
                  if (typeof (res.data.response.errors) === "string") {
                    this.props.history.state = {
                      status: 'error',
                      msg: 'API.' + res.data.response.errors,
                      show: true,
                    };
                    this.setState({isError: !this.state.isError})

                  } else {
                    res.data.response.errors.forEach(innerData => {
                      this.props.history.state = {
                        status: 'error',
                        msg: 'API.' + innerData.msg,
                        show: true,
                      };
                      this.setState({isError: !this.state.isError})
                    })
                  }
                }
              }

            });
          },
        );
    } else {
      this.props.history.state = {
        status: 'error',
        msg: 'API.INVALID_CREDENTIALS',
        show: true,
      };
      this.setState({isError: !this.state.isError})
    }
  }; */

  submitLogin = async () => {
    const {
      formValues,
      history,
      getPermission,
    } = this.props;

    const {
      isError,
    } = this.state;

    let {
      appCheck: stateAppCheck,
    } = this.state;

    const {
      userName,
      password,
      iterationCount,
    } = formValues;

    if (CheckIfNotEmpty(userName) && CheckIfNotEmpty(password) && CheckIfNotEmpty(iterationCount) && CheckIfIterationCountIsValid(iterationCount)) {
      const credentials = await EncryptionServices.generateCredential(userName, password, iterationCount);

      const ssoObject = {
        sso: this.sso,
        redirectURI: this.redirectURI,
        portal: this.portal,
      };

      const res = await doLogin(credentials, ssoObject);

      const { data } = res;

      if (data && data.status === 200 && data.response && data.response.token) {
        const decVal = await EncryptionServices.decodeJwtToken(data.response.token);

        const appType = process.env.REACT_APP_AUDIENCE_TYPE;
        const roleId = decVal.role.id;

        if ([1, 2, 4, 6].includes(roleId) && (appType)?.trim() === 'AdminApp') {
          this.setState({
            appCheck: true,
          });
          stateAppCheck = true;
        }

        if (roleId === 3 && (appType)?.trim() === 'ClientApp') {
          this.setState({
            appCheck: true,
          });
          stateAppCheck = true;
        }
        // eslint-disable-next-line react/destructuring-assignment
        if (!stateAppCheck) {
          history.state = {
            status: 'error',
            msg: 'API.INVALID_CREDENTIALS',
            show: true,
          };

          this.setState({ isError: !isError });
        } else {
          sessionStorage.setItem('cred', JSON.stringify(data.response));
          sessionStorage.setItem('displayImg', data.response.userData.avatar);
          sessionStorage.setItem('userRole', decVal.role.roleName);

          if (decVal.challenged) {
            if (decVal.defaultAuthMethod === constants.TFA_METHODS.sms2fa) {
              history.push('/verify-sms');
            } else if (decVal.defaultAuthMethod === constants.TFA_METHODS.u2f) {
              history.push('/verify-securityKey');
            } else {
              history.push('/otp');
            }
          } else if (data.response.userData) {
            const { sso } = data.response.userData;

            if (sso) {
              const {
                error,
                errorMessage,
                access_code: accessCode,
                redirect_uri: redirectUri,
              } = data.response.userData;

              if (error) {
                if (redirectUri.includes('http')) {
                  window.location.href = `${redirectUri}?accessCode=''&error=${error}&errorMessage=${errorMessage}`;
                } else {
                  window.location.href = `https://${redirectUri}?accessCode=''&error=${error}&errorMessage=${errorMessage}`;
                }
              } else if (redirectUri.includes('http')) {
                window.location.href = `${redirectUri}?accessCode=${accessCode}`;
              } else {
                window.location.href = `https://${redirectUri}?accessCode=${accessCode}`;
              }
            } else {
              sessionStorage.setItem('cred', JSON.stringify(data.response));
              AuthService.authenticate(data.response.token);
              getPermission();
              history.push('/');
            }
          } else {
            history.state = {
              status: 'error',
              msg: 'API.INVALID_CREDENTIALS',
              show: true,
            };

            this.setState({ isError: !isError });
          }
        }
      } else if (res && res?.data) {
        if (!res.data.response) {
          history.state = {
            status: 'error',
            msg: res.data,
            show: true,
          };

          this.setState({ isError: !isError });
        } else if (typeof (res?.data?.response?.errors) === 'string') {
          history.state = {
            status: 'error',
            msg: res?.data?.response?.errors,
            show: true,
          };
          this.setState({ isError: !isError });
        } else {
          res?.data?.response?.errors.forEach((innerData) => {
            history.state = {
              status: 'error',
              msg: innerData.msg,
              show: true,
            };
            this.setState({ isError: !isError });
          });
        }
      }
    } else {
      history.state = {
        status: 'error',
        msg: 'API.INVALID_CREDENTIALS',
        show: true,
      };

      this.setState({ isError: !isError });
    }
  };

  render() {
    const {
      classes,
      logo,
      changeTheme,
      handleSubmit,
      pristine,
      valid,
      submitting,
      ...other
    } = this.props;

    const { isClient } = this.state;

    return (
      <div className={classes.main}>

        <AppBar position="static" className={classes.header}>
          <Toolbar>
            <img className={classes.headerLogo} src={headerLogo} alt="header logo" />
            <Typography variant="h6" className={classes.title} />

            {isClient ? (
              <Link component={RouterLink} to="/request-demo" style={{ textDecoration: 'none' }}>
                <Button className={classes.activeButton} style={{ padding: '0px 26px' }}>
                  Request Demo
                </Button>
              </Link>
            ) : ''}
            <Button color="inherit" onClick={changeTheme}>
              {logo ? (
                <img src={darkLogo} alt="login logo" />
              ) : (
                <img src={lightLogo} alt="login logo" />
              )}

            </Button>
          </Toolbar>
        </AppBar>

        <Container maxWidth="xl" className={classes.mainLogin}>

          <Grid container spacing={0} style={{ height: '100%' }}>

            <Grid item xs={12} sm={12} md={6} lg={7} className={classes.loginLeft}>

              <Grid container spacing={0}>

                <Grid item xs={12}>
                  <div className="rightLogo">

                    {logo ? (
                      <img src={dmLogo} alt="login logo" />
                    ) : (
                      <img src={lmLogo} alt="" />
                    )}

                    <div style={{ alignSelf: 'center' }}>
                      <p>
                        Rev
                        <span>Bits</span>
                      </p>
                      <span>SOFTWARE UPDATE PORTAL</span>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} />

              </Grid>

            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={5} style={{ display: 'flex' }}>

              <div className={classes.loginRight}>

                <Grid
                  container
                  spacing={0}
                  alignItems="flex-end"
                  className={classes.mobileLogo}
                >
                  <Grid item xs={12}>
                    {logo ? (
                      <img src={dmLogo} alt="login logo" width="auto" height="120" />
                    ) : (
                      <img src={lmLogo} alt="" width="auto" height="120" />
                    )}

                  </Grid>
                  <Grid item xs={12}>
                    <h1 className={classes.mobileHeading}>Welcome Back!</h1>
                  </Grid>
                </Grid>

                <form
                  className="loginForm"
                  name="loginForm"
                  onSubmit={handleSubmit(this.submitLogin)}
                  noValidate
                  autoComplete="off"
                >

                  <CustomMessages {...other} />

                  <Grid container alignItems="flex-end" className={classes.marginBottom}>

                    <Grid item className={classes.formInput}>
                      <Field
                        validate={[requiredUserName, email]}
                        component={renderTextField}
                        id="name"
                        name="userName"
                        type="email"
                        label={<Trans>LOGIN.EMAIL</Trans>}
                        classes={classes}
                        icon={<Mail />}
                      />
                    </Grid>
                  </Grid>

                  <Grid container alignItems="flex-end" className={classes.marginBottom}>

                    <Grid item className={classes.formInput}>
                      <Field
                        validate={[requiredPassword]}
                        component={PasswordField}
                        id="password"
                        name="password"
                        type="password"
                        label={<Trans>LOGIN.PASS</Trans>}
                        classes={classes}
                      />

                    </Grid>

                  </Grid>

                  <Grid container alignItems="flex-end" className={classes.marginBottom}>
                    <Grid item className={classes.formInput}>
                      <Field
                        validate={[requiredIterationCount]}
                        component={renderTextField}
                        id="iterationCount"
                        name="iterationCount"
                        type="text"
                        label={<Trans>LOGIN.ITC</Trans>}
                        classes={classes}
                        icon={<Autorenew />}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    justify="flex-end"
                    className={`${classes.linkCss} ${classes.registerUser} ${classes.loginUser}`}
                  >
                    {/* className={`${classes.linkCss} ${classes.registerUser} ${classes.loginUser}`}> */}

                    <Button
                      type="submit"
                      disabled={pristine || !valid || submitting}
                      className={classes.activeButton}
                    >
                      <Trans>LOGIN.BTN</Trans>
                      <img src={LoginBackButton} alt="" />
                    </Button>

                  </Grid>
                  <Grid
                    container
                    justify="flex-end"
                    className={`${classes.linkCss} ${classes.forgotPassword}`}
                  >
                    <Grid item>
                      <Link component={RouterLink} to="/forgot-password">
                        <Trans>FORGOT_YOUR_PASSWORD</Trans>
                      </Link>

                    </Grid>

                    <Grid item xs={12}>
                      <img src={headerLogo} className={classes.footerLogo} alt="header logo" />
                    </Grid>

                  </Grid>

                </form>
              </div>
            </Grid>

          </Grid>

        </Container>

        <AppBar className={classes.footer} position="fixed" color="primary">

          <Toolbar>
            <Typography variant="subtitle2" className={classes.title} style={{ textAlign: 'center' }}>
              ©
              {' '}
              {new Date().getFullYear()}
              {' '}
              RevBits Software Update Portal.
              {' '}
              <span>
                All Rights Reserved.
              </span>
            </Typography>
          </Toolbar>
        </AppBar>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formValues: getFormValues('login')(state),
});

const stylesheets = reduxForm({
  form: 'login',
  onSubmit,
})(withStyles(styles, { withTheme: true })(Login));

export default withTranslation()(
  connect(
    mapStateToProps,
  )(stylesheets),
);
